<!--
	作者：offline
	时间：2019-04-15
	描述：报警事件下拉适配
-->
<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
    <div>
        <Row>
            <Col span="8" v-if="this.errorData.lastTime != undefined">
                <span>{{ errorData.lastTime }}： </span>
                <span>{{ rowData.lastTime }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.interval != undefined">
                <span>{{ errorData.interval }}： </span>
                <span>{{ rowData.interval }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.isUsing != undefined">
                <span>{{ errorData.isUsing }}： </span>
                <span>{{ rowData.isUsing }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.isValveClosed != undefined">
                <span>{{ errorData.isValveClosed }}： </span>
                <span>{{ rowData.isValveClosed }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.velocity != undefined">
                <span>{{ errorData.velocity }}： </span>
                <span>{{ rowData.velocity }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.pipePressure != undefined">
                <span>{{ errorData.pipePressure }}： </span>
                <span>{{ rowData.pipePressure }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.atmosphericPressure != undefined">
                <span>{{ errorData.atmosphericPressure }}： </span>
                <span>{{ rowData.atmosphericPressure }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.pipeTemperature != undefined">
                <span>{{ errorData.pipeTemperature }}： </span>
                <span>{{ rowData.pipeTemperature }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.indoorTemperature != undefined">
                <span>{{ errorData.indoorTemperature }}： </span>
                <span>{{ rowData.indoorTemperature }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.factoryRatio1 != undefined">
                <span>{{ errorData.factoryRatio1 }}： </span>
                <span>{{ rowData.factoryRatio1 }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.factoryRatio2 != undefined">
                <span>{{ errorData.factoryRatio2 }}： </span>
                <span>{{ rowData.factoryRatio2 }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.factoryRatio3 != undefined">
                <span>{{ errorData.factoryRatio3 }}： </span>
                <span>{{ rowData.factoryRatio3 }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.factoryRatio4 != undefined">
                <span>{{ errorData.factoryRatio4}}： </span>
                <span>{{ rowData.factoryRatio4 }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.currentRatio1 != undefined">
                <span>{{ errorData.currentRatio1 }}： </span>
                <span>{{ rowData.currentRatio1 }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.currentRatio2 != undefined">
                <span>{{ errorData.currentRatio2 }}： </span>
                <span>{{ rowData.currentRatio2 }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.currentRatio3 != undefined">
                <span>{{ errorData.currentRatio3 }}： </span>
                <span>{{ rowData.currentRatio3 }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.currentRatio4 != undefined">
                <span>{{ errorData.currentRatio4 }}： </span>
                <span>{{ rowData.currentRatio4 }}</span>
            </Col>
            <Col span="8" v-if="this.errorData.param != undefined">
                <span>{{ errorData.param }}： </span>
<<<<<<< HEAD
                <span v-if="this.errorData.params == undefined"> {{ rowData.param }}</span>
                <span v-if="this.errorData.params != undefined"> {{ errorData.params[rowData.param] }}</span>
=======
                <span v-if="this.errorData.params == undefined" >{{ rowData.param }}</span>
                <span v-if="this.errorData.params != undefined" >{{ errorData.params[rowData.param] }}</span>
>>>>>>> 7a329f0e3b5c7e8286946b5fb3ec0050c778db3e
            </Col>
        </Row>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        },
        data(){
        	return {
        		rowData : this.row,
        		errorData : {}
        	};
        },
        mounted(){
        	this.errorData = global.errorMsgParam[this.rowData.errorNumberNo];
        	//console.log(this.rowData);
        }
        
    };
</script>